var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4757 11.3316L22.4707 11.3113L19.6218 4.07246C19.4949 3.66367 19.1166 3.38184 18.6875 3.38184H7.13981C6.70817 3.38184 6.32477 3.66875 6.20289 4.08262L3.53942 11.2479L3.5318 11.2656L3.52672 11.2859C3.49371 11.4104 3.48356 11.5373 3.50133 11.6617C3.49879 11.7023 3.49625 11.743 3.49625 11.7836V21.074C3.49625 21.9246 4.18942 22.6178 5.04 22.6178H20.965C21.8156 22.6178 22.5088 21.9246 22.5113 21.074V11.7836C22.5113 11.7506 22.5113 11.7176 22.5088 11.6896C22.5189 11.5652 22.5088 11.4459 22.4757 11.3316ZM14.9652 10.24L14.9576 10.6387C14.9373 11.7787 14.1502 12.5455 13 12.5455C12.4389 12.5455 11.9564 12.3652 11.6086 12.0225C11.2607 11.6797 11.0703 11.2023 11.0602 10.6387L11.0525 10.24H5.82715L7.8457 5.33203H17.9816L20.0561 10.24H14.9652ZM9.43785 12.1907H5.44391V20.6686H20.5564V12.1907H16.5828C16.2984 12.8559 15.8591 13.4094 15.2955 13.8055C14.6531 14.2575 13.8584 14.4961 13.0027 14.4961C11.3675 14.4961 10.0548 13.6405 9.43785 12.1907Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.f518504496112f4983ccd4b7d5f967e1.svg";
export { ForwardRef as ReactComponent };